module.exports = __webpack_public_path__ + "static/media/exit.eaf3d8b0.svg";